module.exports = __webpack_public_path__ + "img/cl_sx_bef.38cd7da3.png";